import { Wrapper, Main, Slogan, Profile, Basic, BasicItem, Social, SocialItem } from "./home.style";

const Home = () => {
  const myAge = new Date().getFullYear() - 1996;
  return (
    <Wrapper>
      <Main>
        <Slogan>
          <h1>Web Development & anything else</h1>
          <p>I believe that we can change the world and the way of we live, using and creating tools with focus on collective and individual evolution</p>
        </Slogan>
        <Profile>
          <img src='https://isaquebc.github.io/curriculum/assets/images/IsaqueCosta-68.jpg' />
          <Basic>
            <BasicItem><p>Isaque Benevides Costa</p></BasicItem>
            <BasicItem><p>age: <span id="age">{myAge}</span></p></BasicItem>
            <BasicItem><p>Brazilian Developer</p></BasicItem>
          </Basic>
          <Social>
            <SocialItem>
              <a href='https://github.com/isaquebc' target='_blank'>
                <img src='https://cdn3.iconfinder.com/data/icons/free-social-icons/67/github_circle_gray-512.png' />
                <label>Github</label>
              </a>
            </SocialItem>
            <SocialItem>
              <a target='_blank' href='https://www.linkedin.com/in/isaque-benevides-costa-303a9490/'>
                <img src='https://cdn3.iconfinder.com/data/icons/free-social-icons/67/linkedin_circle_gray-512.png'/>
                <label>Linkedin</label>
              </a>
            </SocialItem>
            <SocialItem>
              <a target='_blank' href='https://api.whatsapp.com/send?phone=5511986756042'>
                <img src='https://cdn2.iconfinder.com/data/icons/social-icons-grey/512/whatsapp-512.png'/>
                <label>WhatsApp</label>
              </a>
            </SocialItem>
          </Social>
        </Profile>
      </Main>
    </Wrapper>
  )
};

export default Home;